<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" *ngIf="userClockInOutService.isEdit" translate> lblEditUserStampInOut </div>
        <div class="popup-title mr-auto" *ngIf="!userClockInOutService.isEdit" translate> lblAddUserStampInOut </div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>
      <form [formGroup]="userClockInForm" (ngSubmit)="onSubmit()">
        <div class="card scrollbar">
          <div class="card-content">
            <div class="card-body">
              <div class="form-row">
                <div class="col-lg-6 col-xl-4 af-form-group">
                  <label for="userId">
                    <span translate> lblSelectUser </span>
                    <span class="text-danger"> * </span>
                  </label>
                  <div class="lbl-info">
                    <ng-select
                      placeholder="{{ 'lblSelectUser' | translate }}"
                      formControlName="userId"
                      [(ngModel)]="selectedUser"
                      required
                    >
                      <ng-option
                        *ngFor="let item of userList"
                        [value]="item.value"
                      >
                        {{ item.text }}</ng-option
                      >
                    </ng-select>
                    <div
                      *ngIf="
                        cpf.userId.invalid &&
                        (cpf.userId.dirty || cpf.userId.touched)
                      "
                      class="help-block text-danger"
                    >
                      <div *ngIf="cpf.userId.errors.required">
                        <span translate>lblUserIsRequired</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-lg-6 col-xl-4 af-form-group">
                  <label for="template-edit-model" translate>
                    lblStampIn <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <div class="date">
                      <input
                        appAfDatepicker
                        class="form-control datePicker width100force"
                        [startDate]="'2011/01/01'"
                        [endDate]="getTodaysDate"
                        [dateTime]="false"
                        placeholder="{{ 'lblStampInFortheDay' | translate }}"
                        formControlName="stampInDate"
                        [(ngModel)]="stampInDate"
                        [ngClass]="{
                          'is-invalid':
                            cpf.stampInDate.invalid && cpf.stampInDate.touched
                        }"
                        required
                      />
                      <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                    <div
                      *ngIf="
                        (cpf.stampInDate.invalid &&
                          (cpf.stampInDate.dirty || cpf.stampInDate.touched)) ||
                        (cpf.stampInTime.invalid &&
                          (cpf.stampInTime.dirty || cpf.stampInTime.touched))
                      "
                      class="help-block text-danger"
                    >
                      <div
                        *ngIf="
                          cpf.stampInDate?.errors?.required ||
                          cpf.stampInTime?.errors?.required
                        "
                      >
                        <span translate>lblStampInRequired</span>
                      </div>
                    </div>
                    <div
                      *ngIf="areStampTimingsInvalid || areStampDatesInvalid"
                      class="help-block text-danger"
                    >
                      <span translate>lblStampDatesAreInvalid</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-2 af-form-group">
                  <div class="date iconfix ml-4">
                    <ngb-timepicker
                      formControlName="stampInTime"
                      required
                    ></ngb-timepicker>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-4 af-form-group">
                  <label for="template-edit-company" translate>
                    lblStampOut
                  </label>
                  <div class="date">
                    <input
                      appAfDatepicker
                      class="form-control datePicker width100force"
                      placeholder="{{ 'lblStampOutFortheDay' | translate }}"
                      formControlName="stampOutDate"
                      [(ngModel)]="stampOutDate"
                      [startDate]="'2011/01/01'"
                      [endDate]="getTodaysDate"
                      [dateTime]="false"
                      [ngClass]="{
                        'is-invalid':
                          cpf.stampOutDate.invalid && cpf.stampOutDate.touched
                      }"
                    />
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>

                <div class="col-lg-6 col-xl-2 af-form-group">
                  <div class="date iconfix ml-4">
                    <ngb-timepicker
                      formControlName="stampOutTime"
                    ></ngb-timepicker>
                  </div>
                </div>
                <div class="col-12 af-form-group">
                    <label for="comment">
                        <span translate>lblComment</span>
                    </label>
                    <div class="lbl-info">
                        <textarea formControlName="comment" class="form-control mb-2"
                            placeholder="{{ 'lblEntercomment' | translate }}" cols="3"
                            maxlength="200" id="comment"></textarea>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light">
          <div class="row">
            <div
              class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15"
            >
              <button
                type="submit"
                class="btn btn-primary btn-lg mr-sm-2"
                [disabled]="
                  !(
                    userClockInForm.valid &&
                    !(areStampTimingsInvalid || areStampDatesInvalid)
                  )
                "
                translate
                aria-label="Center Align"
              >
                <em class="fa fa-plus font16 align-top mr-2" *ngIf="!userClockInOutService.isEdit"></em> 
                <span *ngIf="userClockInOutService.isEdit" translate> lblSaveChanges </span>
                <span *ngIf="!userClockInOutService.isEdit" translate> lblAdd </span>
              </button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>
                <em class="far fa-times-circle font16 align-top mr-2"></em>
                lblCancel
              </a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
